import React, { useState, useEffect, useContext } from "react";
import { EnvironmentContext } from "../../EnvironmentContext";
import apiconfig from "../../config/config";
import { useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import { setEventDetails } from "../../Redux/Actions";
import APIServices from "../../services/APIServices";
import "./Bookingmanagementview.css";
import { useDispatch } from "react-redux";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import moment from "moment-timezone";
import "moment-timezone/data/packed/latest.json";
import { Toolbar } from "@mui/material";
import { DataGridComponent } from "../../Components/PaginationComponent";
import ButtonCompo from "../../Components/ButtonComponent/ButtonCompo";
import { useNavigate } from "react-router-dom";
import { setAccessToken } from "../../Redux/Actions";

const Bookingmanagementview = ({ bookingManagementLength, setBookingManagementLength, setViewed }) => {
  moment.tz.add(
    "Asia/Calcutta|HMT BURT IST IST|-5R.k -6u -5u -6u|01232|-18LFR.k 1unn.k HB0 7zX0"
  );
  moment.tz.link("Asia/Calcutta|Asia/Kolkata");
  const { environment } = useContext(EnvironmentContext);
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false);
  const [randomNumber, setRandomNumber] = useState(false)
  const location = useLocation();
  const dispatch = useDispatch();
  const params = useParams();
  const eventId = params?.eventId;
  const userId = location.state.userId;
  const objectId = location?.state?.objectId
  const eventObjId = location?.state?.eventId
  const eventDetails = useSelector((state) => state?.eventDetails);
  const accessToken = useSelector((state) => state.accessToken);
  const adminDetails = useSelector((state) => state?.loginUserDetails);


  const adminMail = adminDetails?.mail
  const testingEnvironmentIds = {
    "support@meetbytravel.com": "669f4adac194ae7c8eb65d50",
    "jayadeep.mettela@ro-one.in": "665d4b21e27fc43df3215575"
  };

  const productionEnvironmentIds = {
    "support@meetbytravel.com": "669f4b370e0130ee414ef469",
    "jayadeep.mettela@ro-one.in": "66750b795ec6ba4ed5e33656"
  };

  let adminUserId;
  if (environment === "Production") {
    adminUserId = productionEnvironmentIds[adminMail];
  } else if (environment === "Testing") {
    adminUserId = testingEnvironmentIds[adminMail];
  }


  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  useEffect(() => {
    APIServices.updateBookingManagementRequestViewed(eventObjId, objectId)
      .then(res => {
        // console.log('updated successfully')
        setBookingManagementLength(bookingManagementLength - 1)
        setViewed(Math.random())
      })
      .catch(err => {
        console.log('Error calling booking management api')
      })
  }, [])

  useEffect(() => {
    const tokenLocal = JSON.parse(localStorage.getItem("token"));
    if (!accessToken && tokenLocal) {
      dispatch(setAccessToken(tokenLocal));
      APIServices.setAuthToken(tokenLocal);
    } else if (!accessToken && !tokenLocal) {
      navigate("/login");
    }
    if (accessToken || tokenLocal) {
      const tokenToUse = accessToken || tokenLocal;
      APIServices.setAuthToken(tokenToUse);
      setIsLoading(true);
      const url = environment === "Production"
        ? apiconfig.production.apiBaseUrl
        : apiconfig.develpoment.apiBaseUrl;

      APIServices.setApiBaseUrl(url);
      APIServices.getEventById(eventId, adminUserId)
        .then((response) => {
          dispatch(setEventDetails(response?.data?.event));
          setIsLoading(false);
        })
        .catch((err) => {
          console.log("Error fetching event details: ", err);
          setIsLoading(false);
        });
    }
  }, [eventId, environment, dispatch, randomNumber, accessToken, navigate, adminUserId]);

  const eventParticipantsArray = eventDetails?.participants;

  const userParticipantsArray = eventParticipantsArray?.filter((eachParticipant) => {
    return eachParticipant?.user_id?._id === userId;
  }
  );

  const refundRequestsArray = userParticipantsArray?.filter((eachParticipant) => {
    return eachParticipant?.reason_unattended !== null;
  }
  );

  const confirmedParticipantsArray = userParticipantsArray?.filter((eachParticipant) => {
    return eachParticipant?.slot_status === "confirmed";
  }
  );

  const mbtUserdetails = userParticipantsArray?.find((eachParticipant) => {
    return eachParticipant.full_name === null;
  });

  const handleApproveRefundAmount = (participant) => {
    setIsLoading(true);
    const body = {
      amount: participant?.refund_amount,
      orderId: participant?.order_id,
      eventId: eventDetails?._id,
      participantId: participant?.id,
    };
    APIServices.refundRequestAfterTripEnd(body)
      .then((response) => {
        // console.log("Refund amount Response: ", response.data);
        setRandomNumber(Math.random())
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Getting Error Wile Refund Process: ", err);
        setIsLoading(false);
      });
  };

  const handleRejectRefund = (participant) => {
    const eventId = eventDetails?._id
    const participantId = participant?.id

    APIServices.refundRejected(eventId, participantId)
      .then((response) => {
        // console.log("Refund Rejected Response: ", response.data);
        setRandomNumber(Math.random())
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Getting Error Wile Rejected Refund Process: ", err);
        setIsLoading(false);
      });

  }

  const columns = [
    {
      field: "requested_date",
      headerName: "Requested Date",
      width: 200,
      cellClassName: "fullname-cell1",
      headerClassName: "custom-header",
    },
    {
      field: "no_of_slots",
      headerName: "No of slots",
      width: 200,
      cellClassName: "fullname-cell1",
      headerClassName: "custom-header",
    },
    {
      field: "refund_amount",
      headerName: "Refund amount",
      width: 200,
      cellClassName: "fullname-cell1",
      headerClassName: "custom-header",
    },
    {
      field: "refund_status",
      headerName: "Refund status",
      width: 200,
      cellClassName: "fullname-cell1",
      headerClassName: "custom-header",
    },
    {
      field: "refund_reason",
      headerName: "Refund reason",
      width: 200,
      cellClassName: "fullname-cell1",
      headerClassName: "custom-header",
    },
    {
      width: 250,
      display: "flex",
      alignItems: "center",
      renderCell: (params) => {
        const { refund_status } = params.row;
        if (refund_status === "Requested") {
          return (
            <div className="booking-maganement-btn-container" style={{ gap: '5px' }}>
              <ButtonCompo btnText="Reject" onClick={() => handleRejectRefund(params.row)} />
              <ButtonCompo btnText="Approve" onClick={() => handleApproveRefundAmount(params.row)} />
            </div>
          );
        } else if (refund_status === "Rejected") {
          return <span style={{ fontFamily: 'Poppins', fontWeight: 'bold', color: '#e34242' }}>Request rejected</span>;
        } else if (refund_status === "PROCESSING" || refund_status === "PENDING") {
          return <span style={{ fontFamily: 'Poppins', fontWeight: 'bold', color: 'Orange' }}>Request initiated</span>;
        } else if (refund_status === "completed") {
          return <span style={{ fontFamily: 'Poppins', fontWeight: 'bold', color: 'green' }}>Refunded</span>;
        } else {
          return null
        }
      },
    },
  ];

  const rows = refundRequestsArray?.map((item) => {
    const [date, time] = item?.refund_requested_datetime || [];
    const formattedDate = date ? moment(date, "DD-MM-YYYY").format("DD/MM/YYYY") : "Invalid date";
    return {
      id: item?._id,
      requested_date: formattedDate,
      no_of_slots: "1",
      refund_amount: item?.amount_paid,
      refund_status: item?.refund_status !== null && item?.refund_status !== undefined
        ? item?.refund_status
        : "Requested",
      refund_reason: item?.reason_unattended,
      order_id: item?.order_id,
    }
  });

  const totalAmountPaid = () => {
    const amoutPaid = parseInt(mbtUserdetails?.amount_paid);
    return amoutPaid * refundRequestsArray?.length;
  };

  return (
    <>
      <Backdrop
        sx={{
          color: "#ffffff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className="event-information-bg-container">
        <div className="event-information-container">
          <div className="details-container">
            <div className="details-content-container">
              <h5 className="information-side-heading">Event ID</h5>
              <p className="information-content">{eventDetails?.ID_event}</p>
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading">Name</h5>
              <p className="information-content">
                {mbtUserdetails?.first_name} {mbtUserdetails?.last_name}
              </p>
            </div>
            {confirmedParticipantsArray?.map((guest, index) => {
              return (
                <div>
                  <div key={index} className="details-content-container">
                    {guest.full_name === null ? null : (
                      <h5 className="information-side-heading">
                        Guest {index + 1}
                      </h5>
                    )}
                    <p className="information-content">{guest?.full_name} </p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="details-container">
            <div className="details-content-container">
              <h5 className="information-side-heading">Email ID</h5>
              <p className="information-content">
                {mbtUserdetails?.user_id?.email}
              </p>
            </div>
            <div className="details-content-container">
              <h5 className="information-side-heading">No of attendees</h5>
              <p className="information-content">
                {confirmedParticipantsArray?.length}
              </p>
            </div>
          </div>
        </div>

        <br></br>
        <p className="upcomingsession-text">Booking Details</p>
        <div className="event-information-bg-container">
          <div className="event-information-container">
            <div className="details-container">
              <div className="details-content-container">
                <h5 className="information-side-heading">Booking Name</h5>
                <p className="information-content">
                  {mbtUserdetails?.first_name} {""} {mbtUserdetails?.last_name}
                </p>
              </div>
              <div className="details-content-container">
                <h5 className="information-side-heading">Booking ID</h5>
                <p className="information-content">
                  {mbtUserdetails?.booking_id}
                </p>
              </div>
              <div className="details-content-container">
                <h5 className="information-side-heading">Booking Date</h5>
                <p className="information-content">
                  {moment(mbtUserdetails?.booking_datetime[0]).format("DD/MM/YYYY")}
                </p>
              </div>
              <div className="details-content-container">
                <h5 className="information-side-heading">Booking Status</h5>
                <p
                  className="information-content"
                  style={{ textTransform: "capitalize" }}
                >
                  {mbtUserdetails?.slot_status}
                </p>
              </div>
              <div className="details-content-container">
                <h5 className="information-side-heading">Type of booking</h5>
                <p className="information-content">
                  {mbtUserdetails?.payment_mode}
                </p>
              </div>
            </div>

            <div className="details-container">
              <div className="details-content-container">
                <h5 className="information-side-heading">Total amount paid </h5>
                <p className="information-content"> {totalAmountPaid()}</p>
              </div>
              <div className="details-content-container">
                <h5 className="information-side-heading">Transaction ID</h5>
                <p className="information-content">
                  {mbtUserdetails?.order_id}
                </p>
              </div>
            </div>
          </div>
          <br></br>
          <p className="upcomingsession-text">Cancellation Requests</p>
          <main style={{ flexGrow: 1 }}>
            <Toolbar />
            <DataGridComponent columns={columns} rows={rows} rowCount={rows.length} />
          </main>
          <div className="totalamount-text">
            <p className="total-amount">Total Amount Refunded</p>
            <h5 className="each-details">1.2 Euro</h5>
          </div>
        </div>
      </div>{" "}
    </>
  );
};

export default Bookingmanagementview;
